import { Buffer } from "buffer";
const IconReact = (color: string = "#fff") => {
  const icon = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17">
  <g fill="none" stroke="${color}" stroke-width="1">
    <rect width="7" height="7" rx="1" stroke="none"/>
    <rect x="0.5" y="0.5" width="6" height="6" rx="0.5" fill="none"/>
  </g>
  <g transform="translate(0 10)" fill="none" stroke="${color}" stroke-width="1">
    <rect width="7" height="7" rx="1" stroke="none"/>
    <rect x="0.5" y="0.5" width="6" height="6" rx="0.5" fill="none"/>
  </g>
  <g transform="translate(10)" fill="none" stroke="${color}" stroke-width="1">
    <rect width="7" height="7" rx="1" stroke="none"/>
    <rect x="0.5" y="0.5" width="6" height="6" rx="0.5" fill="none"/>
  </g>
  <g  transform="translate(10 10)" fill="none" stroke="${color}" stroke-width="1">
    <rect width="7" height="7" rx="1" stroke="none"/>
    <rect x="0.5" y="0.5" width="6" height="6" rx="0.5" fill="none"/>
  </g>
</svg>
    `;
  const base64 =
    "data:image/svg+xml;base64," + Buffer.from(icon).toString("base64");
  return base64;
};

export default IconReact;
